import React from 'react';

import { withStyles } from '@mui/styles';

import CommonStyles from './CommonStyles';
import ComponentWrapper from './ComponentWrapper';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const styles = {
  accordeon: {
    background: '#fff',
    padding: '4px 8px',
    borderRadius: '8px',
    border: "2px solid transparent",
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    height: '30px',
    padding: '0px 0px 0px 10px',
    userSelect: 'none',
  },
  title: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
    fontSize: '13',
    alignSelf: 'stretch',
  },
  accordeonContent: {
    background: '#fff',
  },
  ...CommonStyles,
};

class Accordeon extends ComponentWrapper {
  render() {
    const { title, classes, isOpened, titleLeftCol, titleRightCol, toggleAccordeon, stylesCover } = this.props;

    return (
      <div className={`${classes.accordeon} accordeon_container`} style={{ ...stylesCover }}>
        <div className={classes.titleContainer}>
          <div onClick={toggleAccordeon} className={`${classes.title} ${classes.pointer}`}>
            <ExpandMoreIcon
              className={classes.mr10}
              style={{
                transform: `${isOpened ? '' : 'rotate(270deg)'}`,
              }}
            />{' '}
            {title}
            {titleLeftCol}
          </div>
          <div style={{ color: '#4C4C4C', whiteSpace: 'nowrap' }}>
            {titleRightCol}
          </div>
        </div>

        {isOpened ? <div className={classes.accordeonContent}>{this.props.children}</div> : null}
      </div>
    );
  }
}

export default withStyles(styles)(Accordeon);
